import { Component, OnInit } from '@angular/core';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Subscription } from 'rxjs';

import { CourtClassInfoModel } from '@bayclubs/court-booking-employee-api';
import { GroupClassAutologinProviderService } from '@core/core.module';
import { CourtEventNoteSaveLauncherService, SaveCourtEventNoteSuccessAction } from '@court-event-note-save/court-event-note-save.module';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { CourtEventInfoFacade } from '../../+store/court-event-info.facade';

@Component({
    selector: 'app-court-class-info-details',
    templateUrl: './court-class-info-details.component.html',
    styleUrls: ['./court-class-info-details.component.scss'],
    standalone: false
})
export class CourtClassInfoDetailsComponent implements OnInit {
    courtClass$ = this.courtEventInfoFacade.courtClassDetails$;

    public courtClassId: string;

    private subscriptions: Subscription = new Subscription();

    constructor(private courtEventInfoFacade: CourtEventInfoFacade,
        private urlService: GroupClassAutologinProviderService,
        private courtEventNoteSaveLauncherService: CourtEventNoteSaveLauncherService,
        private actions$: Actions,
        private readonly modalRef: BsModalRef) { }

    ngOnInit(): void {
        this.courtEventInfoFacade.loadCourtClassDetails(this.courtClassId);

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(SaveCourtEventNoteSuccessAction)).subscribe(() => {
                this.courtEventInfoFacade.loadCourtClassDetails(this.courtClassId);
            })
        );
    }

    ngOnDestroy(): void {
        this.courtEventInfoFacade.clearLoadedCourtClass();

        this.subscriptions.unsubscribe();
    }

    close(): void {
        this.modalRef.hide();
    }

    edit() { }

    isAnyNote(courtClass: CourtClassInfoModel): boolean {
        return courtClass.notes?.length > 0;
    }

    groupClassesUrl() {
        const url = this.urlService.getGroupClassDetailsUrl(this.courtClassId);
        return url;
    }

    onAddNote(): void {
        this.courtEventNoteSaveLauncherService.openCourtNoteSave({ courtEventId: this.courtClassId });
    }

    details(): void {
        this.courtEventInfoFacade.goToCourtClassDetails(this.courtClassId);
        this.close();
    }
}
